import styled, { css } from 'styled-components'

import { helpers } from '../../styles/theme'

export type FocusVisibleProps = {
	isFocusVisible?: boolean
}

/**
 * For full-width buttons, this inset can be shown inside as a focus-visible
 * indicator.
 *
 * Make sure the containing element is `position: relative` to allow positioning
 * to work.
 */
export const FocusVisibleInset = styled.div<FocusVisibleProps>`
	display: ${({ isFocusVisible }) => (isFocusVisible ? 'block' : 'none')};
	position: absolute;
	inset: 2px 4px;
	border-radius: 6px;
	border: 2px solid ${helpers.color.button.focusOutline};
	pointer-events: none;
	transition: border-color 0.1s ease-in-out;
`

/**
 * Reusable styling for showing an external focus indicator.
 */
export const focusVisibleOutline = css<object>`
	outline: ${(props) => {
		const { isFocusVisible } = props as typeof props & FocusVisibleProps

		return isFocusVisible ? `2px solid ${helpers.color.button.focusOutline}` : 'none'
	}} !important;
	outline-offset: 2px;
	transition: outline-color 0.1s ease-in-out;
`
